import { useEffect } from 'react'

import {
  Box, DashboardModule,
} from '@domain-group/suit-theme'

import ScopedConditionalContent from '@components/ScopedConditionalContent'

import useOrderItem from '@hooks/useOrderItem'

import useArtworkPages from '@hooks/useArtworkPages'
import useArtworkPagePreview from '@hooks/useArtworkPagePreview'

import type { OrderItemModel } from '@models/types'

import Actions from '../Actions'
import ArtworkPagePreview from './ArtworkPagePreview'
import BrandedArtworkConversation from './BrandedArtworkConversation'
import BrandedOrderItemHeader from './BrandedOrderItemHeader'

interface OrderItemProps {
  accentColor?: string,
  fontColor?: string,
  orderItem: OrderItemModel,
}

const OrderItem = (props: OrderItemProps) => {
  const { accentColor, fontColor, orderItem } = props

  const orderItemPayload = useOrderItem(orderItem)
  const {
    artwork,
    orderItem: {
      artwork_id,
    },
    service,
  } = orderItemPayload

  const artworkPagesPayload = useArtworkPages({ filters: { artwork_id } })
  const {
    filteredArtworkPages,
    filteredArtworkPagesCount,
  } = artworkPagesPayload

  const firstArtworkPagePreview = filteredArtworkPages[0]?.previews?.large
  const secondArtworkPagePreview = filteredArtworkPages[1]?.previews?.large

  const artworkPageOptions = { ablyPublicKey: process.env.REACT_APP_ABLY_ARTWORK_BUILDER_PUBLIC_KEY || '' }
  const artworkPagePreviewPayload = useArtworkPagePreview(artworkPageOptions)
  const { callbacks: { buildPreview }, buildingRef: { current: buildingArtworkPreview } } = artworkPagePreviewPayload

  // we typically only build the first page preview
  // build the second page preview if it doesn't already exist
  useEffect(() => {
    if (filteredArtworkPagesCount > 1 && !secondArtworkPagePreview){
      buildPreview({ artworkPage: filteredArtworkPages[1] })
    }
  }, [filteredArtworkPages[1]?.cache_key])

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      customHeader={(
        <BrandedOrderItemHeader
          // @ts-expect-error TS2322
          accentColor={accentColor}
          orderItem={orderItem}
          service={service}
        />
      )}
      boxProps={{
        marginBottom: 'xlarge',
      }}
    >
      <Box>
        {/*
         // @ts-expect-error TS2322 */}
        {!!filteredArtworkPagesCount && <ArtworkPagePreview accentColor={accentColor} url={firstArtworkPagePreview} />}

        {filteredArtworkPagesCount > 1 && (
          <ArtworkPagePreview
            // @ts-expect-error TS2322
            accentColor={accentColor}
            loading={buildingArtworkPreview}
            secondPreview
            url={secondArtworkPagePreview}
          />
        )}
      </Box>

      <Actions orderItemPayload={orderItemPayload} pageCount={filteredArtworkPagesCount} />

      <ScopedConditionalContent permittedRoleTitles={['Agent', 'Office Administrator', 'Office Director']}>
        <BrandedArtworkConversation
          accentColor={accentColor}
          artwork={artwork}
          fontColor={fontColor}
        />
      </ScopedConditionalContent>
    </DashboardModule>
  )
}

export default OrderItem
